<template>
	<div class="row fill-height">
		<div class="col fill-height">
			<p>{{ questionType }}</p>
		</div>
	</div>
</template>

<script>
import QuestionType from "root/packages/closeapp/QuestionsManager/assets/types/QuestionType";
export default {
	name: "TypeDisplay",
	props: ["type"],

	computed: {
		questionType() {
			let questionTypes = QuestionType.getAsOption();
			return questionTypes[this.type.question_type - 1].text;
		}
	}
};
</script>
